import { render, staticRenderFns } from "./ledScreenConfigForm.vue?vue&type=template&id=4c9c7faf&scoped=true&"
import script from "./ledScreenConfigForm.vue?vue&type=script&lang=js&"
export * from "./ledScreenConfigForm.vue?vue&type=script&lang=js&"
import style0 from "./ledScreenConfigForm.vue?vue&type=style&index=0&id=4c9c7faf&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c9c7faf",
  null
  
)

export default component.exports